import moment from 'moment';
// import { tryElectronPrint } from './printElectron';
import { getSuperGroupName } from '../utils/getSuperGroupName';

const defineCss = () => `
  body { 
    font-family: Arial, sans-serif; 
    margin: 20px; 
    font-size: 12px;
  }
  .header { 
    text-align: center; 
    margin-bottom: 20px; 
    border-bottom: 2px solid #000;
    padding-bottom: 10px;
  }
  .company-name {
    font-size: 18px;
    font-weight: bold;
    color: #2c5aa0;
  }
  .report-title {
    font-size: 16px;
    font-weight: bold;
    margin: 5px 0;
  }

  .date-info {
    font-size: 14px;
    margin: 5px 0;
  }

  table { 
    width: 100%; 
    border-collapse: collapse; 
    margin: 10px 0;
    font-size: 11px;
  }

  th, td { 
    border: 1px solid #000; 
    padding: 4px 6px; 
    text-align: left;
  }
  th { 
    background-color: #f0f0f0; 
    font-weight: bold;
    text-align: center;
  }

  .category-section {
    margin: 15px 0;
    page-break-inside: avoid;
  }

  .category-title {
    font-weight: bold;
    background-color: #e6f3ff;
    padding: 5px;
    margin: 5px 0;
    border: 1px solid #000;
  }

  .summary-section {
    margin-top: 20px;
    border-top: 2px solid #000;
    padding-top: 10px;
  }

  .total-row {
    font-weight: bold;
    background-color: #f5f5f5;
  }
  .text-center { text-align: center; }

  .text-right { text-align: right; }

  @media print {
    body { margin: 0; }
    .no-print { display: none; }
  }

  @page {
    margin: 12mm 10mm;
    size: A4;
  }
`;

const generatePrintableContent = (superGroups, orders, reportTitle) => {

  const sgs = Array.isArray(superGroups) ? superGroups : [];
  const rows = Array.isArray(orders) ? orders : [];

  // console.log('sgs', sgs);
  // console.log('rows', rows);

  const printingTime = moment().format('hh:mm A');
  const collectionDate = rows.length > 0 && rows[0].createdAt ? moment(rows[0].createdAt).format('DD-MMMM-YYYY') : moment().format('DD-MMMM-YYYY');

  const totalsBySG = {};
  const commissionsBySG = {};
  let overallTotal = 0;
  let overallCommission = 0;

  rows.forEach(order => {
    sgs.forEach(sg => {
      const testData = order.tests && order.tests[sg] ? order.tests[sg] : { total: 0, commission: 0 };
      const val = Number(testData.total || 0);
      const comm = Number(testData.commission || 0);

      totalsBySG[sg] = (totalsBySG[sg] || 0) + val;
      commissionsBySG[sg] = (commissionsBySG[sg] || 0) + comm;

      overallTotal += val;
      overallCommission += comm;
    });
  });

  const headerCols = sgs.map(sg => `<th>${getSuperGroupName(sg)}</th>`).join('');

  // console.log('headerCols', headerCols);


  const bodyRows = rows.map(order => {
    let rowTotal = 0;
    let rowCommission = 0;

    const sgCols = sgs.map(sg => {
      const testData = order.tests && order.tests[sg] ? order.tests[sg] : { total: 0, commission: 0 };
      const val = Number(testData.total || 0);
      const comm = Number(testData.commission || 0);

      rowTotal += val;
      rowCommission += comm;

      // console.log(`Order ${order.testOrderID} - ${sg}: ${val}, Commission: ${comm}`);
      return `<td class="text-center">৳${val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>`;
    }).join('');

    const endDate = order.lastPaymentDate ? new Date(order.lastPaymentDate).toLocaleDateString() : '';

    return `
      <tr>
        <td class="text-center">${order.createdAt ? new Date(order.createdAt).toLocaleDateString() : '-'}</td>
        <td class="text-center">${order.testOrderID || 'N/A'}</td>
        <td class="text-center">${order.paymentType || '-'}</td>
        ${sgCols}
        <td class="text-center">৳${rowTotal.toFixed(2)}</td>
        <td class="text-center">৳${rowCommission.toFixed(2)}</td>
        <td class="text-center">${order.lastPaymentDate ? new Date(order.lastPaymentDate).toLocaleDateString() : '-'}</td>
      </tr>
    `;
  }).join('');

  const totalsCols = sgs.map(sg => `<td class="text-right"><strong>৳${(totalsBySG[sg] || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></td>`).join('');
  const commissionsCols = sgs.map(sg => `<td class="text-right"><strong>৳${(commissionsBySG[sg] || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></td>`).join('');

  return `
    <div class="header">
      <div class="company-name">MEDIPLUS MEDICAL SERVICES (Pvt) LTD.</div>
      <div class="report-title">${reportTitle || 'Commission Report'}</div>
      <div class="date-info">Date: ${collectionDate} <br/> Printing Time: ${printingTime}</div>
    </div>

    <table>
      <thead>
        <tr>
          <th>Date</th>
          <th>Order ID</th>
          <th>Remarks</th>
          ${headerCols}
          <th>Total</th>
          <th>Commission</th>
          <th>End Date</th>
        </tr>
      </thead>
      <tbody>
        ${bodyRows}
        <tr class="total-row">
          <td colspan="3"><strong>Total (${rows.length} Orders)</strong></td>
          ${totalsCols}
          <td class="text-center"><strong>৳${overallTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></td>
          <td class="text-center"><strong>৳${overallCommission.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></td>
          <td></td>
        </tr>
        <tr class="total-row">
          <td colspan="3"><strong>Total Commission</strong></td>
          ${commissionsCols}
          <td class="text-center"><strong>৳${overallCommission.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></td>
          <td class="text-center"><strong>৳${overallCommission.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></td>
          <td></td>
        </tr>
      </tbody>
    </table>

    <div class="summary-section">
      <h3>Summary</h3>
      <p><strong>Total Orders:</strong> ${rows.length}</p>
      <p><strong>Total Amount:</strong> ৳${overallTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
      <p><strong>Total Commission:</strong> ৳${overallCommission.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
    </div>

    <div style="margin-top:40px;text-align:right;">
      <div style="display:inline-block;width:220px;border-top:1px dotted #000;padding-top:6px;">Signature</div>
    </div>
  `;
};

const printCommissionReport = (superGroups, orders, reportTitle) => {
  // 1. Create a hidden iframe to execute print securely
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0px';
  iframe.style.height = '0px';
  iframe.style.border = 'none';
  document.body.appendChild(iframe);

  const printWindow = iframe.contentWindow;
  if (!printWindow) {
    console.error('[printCommissionReport] Hidden iframe context is unavailable.');
    alert('Failed to initialize print process. Please try again.');
    document.body.removeChild(iframe);
    return;
  }

  const sgs = Array.isArray(superGroups) ? superGroups : [];
  const rows = Array.isArray(orders) ? orders : [];

  if (!rows || rows.length === 0) {
    console.warn('No orders provided to print');
    return;
  }

  const collectionDate = rows.length > 0 && rows[0].createdAt
    ? moment(rows[0].createdAt).format('DD-MMMM-YYYY')
    : moment().format('DD-MMMM-YYYY');
  const printTitle = `${reportTitle || 'Commission Report'} - ${collectionDate}`;
  const printContent = generatePrintableContent(sgs, rows, reportTitle) || '<div style="padding:20px;">No data to print</div>';

  const fullHtml = `
    <html>
      <head>
        <title>${printTitle}</title>
        <style>
          ${defineCss()}
        </style>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
  `;

  // 2. Safely output the HTML markup to the iframe window context
  printWindow.document.write(fullHtml);
  printWindow.document.close();

  // 3. Focus, print, call back, and safely garbage-collect the temporary iframe
  setTimeout(() => {
    // const didElectronPrint = tryElectronPrint(printWindow);
    // if (!didElectronPrint) {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
    // }
    document.body.removeChild(iframe);
  }, 500);
};

export default printCommissionReport;
